import { render, staticRenderFns } from "./number-field-item.vue?vue&type=template&id=b4baf23a&scoped=true&"
import script from "./number-field-item.vue?vue&type=script&lang=js&"
export * from "./number-field-item.vue?vue&type=script&lang=js&"
import style0 from "./number-field-item.vue?vue&type=style&index=0&id=b4baf23a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4baf23a",
  null
  
)

export default component.exports